module.exports = __webpack_public_path__ + "img/icon_zhiwen@2x.a9e31bdc.png";